// ISBN: curățare, validare (checksum) și conversie ISBN-10 → ISBN-13.

export function cleanIsbn(raw: string): string {
  return (raw || '').toUpperCase().replace(/[^0-9X]/g, '');
}

export function isValidIsbn13(s: string): boolean {
  if (!/^\d{13}$/.test(s)) return false;
  const sum = s.split('').reduce((acc, d, i) => acc + Number(d) * (i % 2 === 0 ? 1 : 3), 0);
  return sum % 10 === 0;
}

export function isValidIsbn10(s: string): boolean {
  if (!/^\d{9}[\dX]$/.test(s)) return false;
  const sum = s.split('').reduce((acc, ch, i) => acc + (ch === 'X' ? 10 : Number(ch)) * (10 - i), 0);
  return sum % 11 === 0;
}

export function toIsbn13(raw: string): string | null {
  const s = cleanIsbn(raw);
  if (isValidIsbn13(s)) return s;
  if (isValidIsbn10(s)) {
    const core = '978' + s.slice(0, 9);
    const sum = core.split('').reduce((acc, d, i) => acc + Number(d) * (i % 2 === 0 ? 1 : 3), 0);
    return core + ((10 - (sum % 10)) % 10);
  }
  return null;
}

// Codurile de bare EAN-13 de pe cărți încep cu 978/979 (Bookland)
export function isBookEan(code: string): boolean {
  const s = cleanIsbn(code);
  return /^97[89]\d{10}$/.test(s) && isValidIsbn13(s);
}
